import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../../types'
import type { GetDraftAccountResponse } from '../../auth.api'
import { getDraftAccount } from '../../auth.api'
import { authCacheKeys } from '../../auth.cacheKeys'

export const useGetDraftAccount = (
  queryOptions?: UseAppQueryOptions<GetDraftAccountResponse>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: authCacheKeys.draftAccount(),
    queryFn: () => getDraftAccount()
  })
}
